<template>
  <div>
    <h1>{{ cityInfo.name }} {{ eventName }} 休日空き件数</h1>
    <div v-if="indoor">
      バドミントン、バレーボール、バスケットボール、フットサル、卓球など
    </div>
    <div>更新日時：{{ updateTime }}</div>
    <table :key="index" v-for="(table, index) in tables">
      <thead>
        <tr>
          <th></th>
          <th :key="place" v-for="place in table.places">{{ place }}</th>
        </tr>
      </thead>
      <tbody>
        <tr :key="ymd" v-for="(dataList, ymd) in table.ymdStatuses">
          <th>{{ ymd }}</th>
          <td
            :key="index"
            v-for="(data, index) in dataList"
            :class="getTdClass(data.ymdCount)"
          >
            <template v-if="data.ymdCount == 0">-</template>
            <template v-else-if="cityInfo.statusLink">
              <router-link
                :to="{
                  name: 'status',
                  params: { city: city, place: table.places[index] },
                }"
                >{{ data.ymdCount }}</router-link
              >
            </template>
            <template v-else>{{ data.ymdCount }}</template>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="statuses" class="info">
      <p>空き件数をクリックすると時間ごとの空き状況が確認できます。</p>
      <div>
        <ul>
          <li>
            <label>公式サイト</label>
            <a :href="cityInfo.url">{{ cityInfo.url }}</a>
          </li>
          <li v-if="cityInfo.lots">
            <label>抽選期間</label>
            <span>{{ cityInfo.lots }}</span>
          </li>
          <li v-if="cityInfo.reservation">
            <label>予約開始日</label>
            <span>{{ cityInfo.reservation }}</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
//import db from "@/firebaseInit";
import { cities } from "./city";

const events = {
  tennis: { name: "テニス" },
  soccer: { name: "サッカー" },
  baseball: { name: "野球" },
  indoor: { name: "屋内施設" }
};

export default {
  name: "Summary",
  props: ["event", "city"],
  data () {
    return {
      statuses: undefined,
      places: undefined
    };
  },
  computed: {
    eventName () {
      return events[this.event].name;
    },
    cityInfo () {
      return cities[this.city];
    },
    indoor () {
      return this.event == "indoor";
    },
    tables () {
      if (!this.places) {
        return [];
      }
      const length = this.places.length;
      if (length <= 6) {
        return this.divedeTable(1);
      } else if (length <= 12) {
        return this.divedeTable(2);
      } else if (length <= 18) {
        return this.divedeTable(3);
      } else if (length <= 24) {
        return this.divedeTable(4);
      }
      return this.divedeTable(5);
    },
    ymdStatuses () {
      if (!this.statuses) {
        return undefined;
      }
      return this.statuses
        .flatMap(doc => doc.date)
        .reduce((acc, obj) => {
          const key = obj.ymd;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {});
    },
    updateTime () {
      if (!this.statuses) {
        return "";
      }
      const date = this.statuses[0].timestamp.toDate();
      return (
        "" +
        date.getFullYear() +
        "/" +
        ("0" + (date.getMonth() + 1)).slice(-2) +
        "/" +
        ("0" + date.getDate()).slice(-2) +
        " " +
        ("0" + date.getHours()).slice(-2) +
        ":" +
        ("0" + date.getMinutes()).slice(-2)
      );
    }
  },
  created: async function () {
    const db = firebase.firestore();
    const snapshot = await db
      .collection(`${this.city}-status-summary`)
      .where("event", "==", this.event)
      .get();
    this.statuses = snapshot.docs.map(doc => doc.data());

    // 日付データ件数が全て同じ場合は特に調整不要
    const dateLengthList = this.statuses.map(s => [s.place, s.date.length]);
    if (Array.from(new Set(dateLengthList)).length === 1) {
      return;
    }

    // 大田区のデータ作成がバグっているので暫定対応
    // if (this.city == "ota") {
    //   this.statuses = this.statuses.map(s => {
    //     s.date = s.date.slice(0, 17);
    //     return s;
    //   })
    //   this.places = Array.from(
    //     new Set(snapshot.docs.map(doc => doc.data().place))
    //   );
    //   return;
    // }

    // 日付データ件数が異なる場合は、場所によってステータスが存在する日付があったりなかったりするため、0埋めで桁合わせをする
    const maxLength = this.statuses
      .map(status => status.date.length)
      .reduce((a, b) => Math.max(a, b));

    const ymdListAll = this.statuses
      .flatMap(status => status.date)
      .map(date => date.ymd);
    const ymdList = Array.from(new Set(ymdListAll));

    this.statuses.forEach(status => {
      const length = status.date.length;
      if (length < maxLength) {
        Array.from(new Array(maxLength - length)).forEach((v, i) => {
          status.date.push({ ymd: ymdList[i + length], ymdCount: 0 });
        });
      }
    });

    this.places = Array.from(
      new Set(snapshot.docs.map(doc => doc.data().place))
    );
  },
  mounted: function () {
    document.title = `${this.cityInfo.name}|${this.eventName}|休日空き情報`;
    document
      .querySelector("meta[name='description']")
      .setAttribute(
        "content",
        `${this.cityInfo.name}の${this.eventName}の休日空き情報を分かりやすく提供しています`
      );
  },
  methods: {
    getTdClass (count) {
      return count == 0 ? "" : "available";
    },
    divedeTable (num) {
      const tables = [];
      // テーブルデータを分割するインデックス
      const sliceIndex = Math.ceil(this.places.length / num);

      Array.from(Array(num), (v, k) => k).forEach(k => {
        const status = {};
        Object.entries(this.ymdStatuses).forEach(([ymd, dateList]) => {
          status[ymd] = dateList.slice(k * sliceIndex, (k + 1) * sliceIndex);
        });
        tables.push({
          places: this.places.slice(k * sliceIndex, (k + 1) * sliceIndex),
          ymdStatuses: status
        });
      });
      return tables;
    }
  }
};
</script>

<style scoped>
.info {
  margin-top: 10px;
}
.info ul {
  list-style: none;
  display: inline-block;
}

.info li {
  text-align: left;
}

.info li label {
  /* margin-right: 10px; */
  width: 80px;
}
</style>